/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Question title and optional subtitle
 * @export
 * @interface PaxCheckQuestionTitle
 */
export interface PaxCheckQuestionTitle {
    /**
     * Question title
     * @type {string}
     * @memberof PaxCheckQuestionTitle
     */
    name: string;
    /**
     * Optional question subtitle
     * @type {string}
     * @memberof PaxCheckQuestionTitle
     */
    subtitle?: string | null;
}

/**
 * Check if a given object implements the PaxCheckQuestionTitle interface.
 */
export function instanceOfPaxCheckQuestionTitle(value: object): value is PaxCheckQuestionTitle {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function PaxCheckQuestionTitleFromJSON(json: any): PaxCheckQuestionTitle {
    return PaxCheckQuestionTitleFromJSONTyped(json, false);
}

export function PaxCheckQuestionTitleFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckQuestionTitle {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'subtitle': json['subtitle'] == null ? undefined : json['subtitle'],
    };
}

export function PaxCheckQuestionTitleToJSON(json: any): PaxCheckQuestionTitle {
    return PaxCheckQuestionTitleToJSONTyped(json, false);
}

export function PaxCheckQuestionTitleToJSONTyped(value?: PaxCheckQuestionTitle | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'subtitle': value['subtitle'],
    };
}

